import React from "react";
import "./Log.css";

const Dashlog = () => {
  return (
    <div className="dashlog-container">
      {/* Full Card */}
      <div className="dashlog-card dashlog-full-card">
        <h2 className="welh2">Welcome To Subandhan nidhi Limited</h2>
      </div>
      

      {/* Half Card */}
      <div className="dashlog-card dashlog-half-card" >
        <h3>Half Card Background</h3>
        {/* Floating bubbles inside half card */}
  <div className="bubble"></div>
  <div className="bubble"></div>
  <div className="bubble"></div>
  <div className="bubble"></div>
  <footer className="footer">
      <p className="welp">HeadOffice Contact Details</p>
      <p className="welp"><strong>Helpline No : </strong> 9905053039</p>
      <p className="welp"><strong>E-mail : </strong>subandhannidhilimited@gmail.com</p>
    </footer>
      </div>

      {/* Mini Card */}
      <div className="dashlog-card dashlog-mini-card">
        
        
        <h4>Login</h4>
        <form>
          <input type="text" placeholder="Username" />
          <input type="password" placeholder="Password" />
          <button type="submit">Login</button>
        </form>
        
      </div>
      
    </div>
    
  );
};

export default Dashlog;
